import React from "react"

import { useComponentizedPage } from "store/contexts/componentized-page"

import SupplementProductDescription from "components/product-description/supplement"
import ClassProductDescription from "components/product-description/class"
import GenericProductDescription from "components/product-description/generic"

const ContentfulProductDescription = ({ component }) => {
  const {
    id,
    classOverride,
    showReviewRating,
    headline,
    productName,
    subheadline,
    description,
    shopifyProductVariant,
  } = component

  const { class: pageClass, shopifyProductVariant: pageShopifyProductVariant } =
    useComponentizedPage()
  const cls = classOverride || pageClass

  if (cls) {
    return (
      <ClassProductDescription
        dataId={id}
        classId={cls.classId}
        headline={headline && headline.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")}
        subheadline={
          subheadline && subheadline.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")
        }
        description={description && description.childMarkdownRemark.html}
      />
    )
  }

  // Set supplement & bold data for supplements
  const variant = shopifyProductVariant || pageShopifyProductVariant
  const shopifyProduct = variant
    ? {
        ...variant.product,
        overrides: {
          headline,
          productName,
          subheadline,
          description,
        },
      }
    : null

  if (shopifyProduct) {
    return (
      <SupplementProductDescription
        dataId={id}
        product={shopifyProduct}
        showReviewRating={showReviewRating}
      />
    )
  }

  return (
    <GenericProductDescription
      dataId={id}
      headline={headline && headline.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")}
      subheadline={
        subheadline && subheadline.childMarkdownRemark.html.replace(/^<p>(.*)<\/p>$/i, "$1")
      }
      description={description && description.childMarkdownRemark.html}
    />
  )
}

export default ContentfulProductDescription
